import { Link } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "../context/context";

function Dropdown({ scroll }) {
  const { state, setState } = useContext(AppContext);

  return (
    <div className="fixed z-20 top-[54px] smd:top-[70px] w-full h-fit flex md:hidden px-2 smd:px-12">
      <div
        className={`w-full h-0 flex flex-col gap-2 px-6 shadow-xl shadow-black/50 text-white ${
          state.showDropdown && "h-52 py-4"
        } bg-[#0fa3a3] rounded-b-2xl duration-500 overflow-hidden`}
      >
        <button onClick={() => scroll("features")} className="w-fit ml-2">
          Overview
        </button>
        <button onClick={() => scroll("details")} className="w-fit ml-2">
          Features
        </button>
        <button onClick={() => scroll("pricing")} className="w-fit ml-2">
          Pricing
        </button>
        <button
          onClick={() => scroll("contactus")}
          className="w-fit ml-2 whitespace-nowrap"
        >
          Contact Us
        </button>

        <div className="w-full h-fit flex gap-4 mt-2">
          <Link
            to="/hrm/login"
            onClick={() => setState({ ...state, showDropdown: false })}
            className="w-fit px-3 py-0.5 flex justify-center border-[2px] rounded-full hover:bg-purp/30 duration-500"
          >
            Login
          </Link>
          <Link
            to="/hrm/signup"
            onClick={() => setState({ ...state, showDropdown: false })}
            className="w-fit px-3 py-0.5 flex justify-center border-[2px] rounded-full hover:bg-purp/30 duration-500"
          >
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Dropdown;
